var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sub_view == 'clientes')?_c('div',[_c('div',{staticClass:"chart-card"},[_c('div',{staticClass:"header"},[_c('h4',[_vm._v("Clientes deudores")]),_c('chart-header-options',{attrs:{"module_name":"client","total_registros_text":_vm.total_registros_text,"registros_para_mostrar":_vm.clients}})],1),_c('deudas-de-clientes')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }